import React, { Component } from "react";
import "./InSlider.css";
import * as d3 from "d3";
import { graphOffsetKey } from "../../../../../constants/constants";
import moment from "moment";

export default class extends Component {
  componentDidMount() {
    this.margin = {
      left: 30,
      right: 30,
      bottom: 30,
      top: 30,
    };
    this.setDimensions(null, () => {
      this.setState({ renderSVG: true });
    });

    window.addEventListener("mouseup", () => {
      this.zoomRectLeftActive = false;
      this.zoomRectRightActive = false;
      this.zoomRectDragActive = false;
    });

    window.addEventListener("mousemove", (e) => {
      if (
        this.zoomRectLeftActive ||
        this.zoomRectRightActive ||
        this.zoomRectDragActive
      ) {
        let mouseX = Math.max(Math.min(e.clientX - 80, this.width), 0);
        this.updateZoomBar(mouseX);
      }
    });
  }

  state = {
    renderSVG: false,
  };

  /**
   *
   *  Setters
   *
   */

  setData = (args) => {
    this.setState({
      starttime: args.xDomainValue[0],
      endtime: args.xDomainValue[1],
    });
    this.setDimensions(args, () => {
      this.calculateDomainValues(args);
      this.setDomains(args);
      this.setAxis(args);
      this.initSVG(args);
      this.clearSVG(args);
      setTimeout(() => {
        this.initDefs(args);
        this.drawAxis(args);
        this.drawCircle(args);
        this.onZoomRect(args);
      }, 100);
    });
  };

  setDimensions = (args, callback) => {
    this.width =
      this.refs.sliderContainer.clientWidth -
      (this.margin.left + this.margin.right);
    this.height = 70;
    this.setState({ height: this.height, width: this.width }, callback);
  };

  calculateDomainValues = (args) => {
    this.xDomainValue = args.xDomainValue;
    this.yDomainValue = [0, this.height];
  };

  setDomains = (args) => {
    this.xDomain = d3
      .scaleTime()
      .range([0, this.width])
      .domain(this.xDomainValue);
    this.yDomain = d3
      .scaleLinear()
      .range([this.height, 0])
      .domain(this.yDomainValue);
  };

  setAxis = (args) => {
    this.xAxis = d3.axisBottom(this.xDomain).ticks(5);
    this.yAxis = d3.axisLeft(this.yDomain).ticks(5);
  };

  initSVG() {
    if (this.refs.svg) {
      this.svg = d3.select(this.refs.svg);
      this.svg.on("contextmenu", function (event) {
        event.preventDefault();
      });
    }
  }

  clearSVG() {
    if (this.svg) {
      this.svg.selectAll("*").remove();
    }
  }

  updateZoomBar = (x) => {
    if (this.zoomRectLeftActive && x < this.rangeRight - 4) {
      this.rangeLeft = x;
      this.zoomRectLeft.attr("x", this.rangeLeft - 8);
      this.zoomRect
        .attr("x", this.rangeLeft)
        .attr("width", this.rangeRight - this.rangeLeft);
    } else if (this.zoomRectRightActive && x > this.rangeLeft + 4) {
      this.rangeRight = x;
      this.zoomRectRight.attr("x", this.rangeRight - 2);
      this.zoomRect.attr("width", this.rangeRight - this.rangeLeft);
    } else if (this.zoomRectDragActive) {
      let left = x - this.zoomRectDragOffset;
      let right = left + (this.rangeRight - this.rangeLeft);
      if (left < 0 || right > this.width) return;

      this.rangeLeft = left;
      this.rangeRight = right;

      this.zoomRectRight.attr("x", this.rangeRight - 2);
      this.zoomRectLeft.attr("x", this.rangeLeft - 8);
      this.zoomRect
        .attr("x", this.rangeLeft)
        .attr("width", this.rangeRight - this.rangeLeft);
    }
    this.setState({
      starttime: this.xDomain.invert(this.rangeLeft).getTime(),
      endtime: this.xDomain.invert(this.rangeRight).getTime(),
    });
    if (this.props.onChange) {
      this.props.onChange([
        this.xDomain.invert(this.rangeLeft).getTime(),
        this.xDomain.invert(this.rangeRight).getTime(),
      ]);
    }
  };

  /**
   *
   */

  initDefs() {
    if (this.svg) {
      this.defs = this.svg.append("defs");
      this.defs
        .append("clipPath")
        .attr("id", "clip-" + this.uid)
        .append("rect")
        .attr("width", this.width)
        .attr("height", this.height);

      this.pathgrad = this.defs
        .append("linearGradient")
        .attr("id", "pathgrad")
        .attr("x1", "50%")
        .attr("y1", "100%")
        .attr("x2", "50%")
        .attr("y2", "0%");

      this.pathgrad
        .append("stop")
        .attr("offset", "0%")
        .attr("style", "stop-color:rgb(153,218,255);stop-opacity:1");

      this.pathgrad
        .append("stop")
        .attr("offset", "100%")
        .attr("style", "stop-color:rgb(0,255,60);stop-opacity:1");

      this.focus = this.svg.append("g").attr("class", "focus");
      // .attr("transform", "translate(0," + (this.height * -1) + ")");

      // this.Context = this.svg.append("g")
      //     .attr("class", "context")
      //     .attr("transform", "translate(" + this.margin.left + "," + this.margin.top + ")");
    }
  }

  drawAxis = () => {
    if (this.focus) {
      this.focus
        .append("g")
        .attr("class", "axis axis--x")
        .attr("transform", "translate(0," + (this.height - 20) + ")")
        .call(this.xAxis);

      this.focus
        .append("g")
        .attr("class", "axis axis--y -transparent")
        // .attr("transform", "translate("+ (axisIndex === 0 ? 0 :this.width) +",0)")
        .call(this.yAxis);
    }
  };

  drawCircle = (args) => {
    if (this.focus) {
      for (let idx in args.data) {
        this.focus
          .append("circle")
          .attr("fill", "#dd2200")
          .attr("r", 3)
          .attr("cx", (d) => this.xDomain(args.data[idx].time))
          .attr("cy", 30);
      }
    }
  };

  onZoomRect = (args) => {
    if (this.focus) {
      this.rangeLeft = 5;
      this.rangeRight = this.width - 5;

      this.zoomRect = this.focus
        .append("rect")
        .attr("fill", "#f00")
        .attr("fill-opacity", 0.1)
        .attr("x", this.rangeLeft)
        .attr("y", 10)
        .attr("stroke", "#333")
        .attr("stroke-width", 1)
        .attr("height", this.height - 30)
        .attr("width", this.rangeRight - this.rangeLeft)
        .attr("class", "zoomBar")
        .on("mousedown", (event) => {
          this.zoomRectDragOffset = event.clientX - 80 - this.rangeLeft;
          this.zoomRectDragActive = true;
        });

      this.zoomRectLeft = this.focus
        .append("rect")
        .attr("fill", "#f00")
        .attr("fill-opacity", 0)
        .attr("class", "leftMove")
        .attr("x", this.rangeLeft - 8)
        .attr("y", 10)
        .attr("height", this.height - 30)
        .attr("width", 10)
        .on("mousedown", (event) => {
          this.zoomRectLeftActive = true;
        });

      this.zoomRectRight = this.focus
        .append("rect")
        .attr("fill", "#f00")
        .attr("fill-opacity", 0)
        .attr("class", "rightMove")
        .attr("x", this.rangeRight - 2)
        .attr("y", 10)
        .attr("height", this.height - 30)
        .attr("width", 10)
        .on("mousedown", (event) => {
          this.zoomRectRightActive = true;
        });
    }
  };

  /**
   *
   *
   *
   */

  getDateString = (time) => moment(time).format("YYYY.MMM.DD hh:mm a");

  /**
   *
   *  Renderers
   *
   */

  render() {
    return (
      <div className="InSlider" ref="sliderContainer">
        <div className="is-heading">
          <div className="ish-time">
            Start Time : {this.getDateString(this.state.starttime)}
          </div>
          <div className="ish-time -right">
            End Time : {this.getDateString(this.state.endtime)}
          </div>
        </div>
        <div className="is-svg">
          <div className="iss-dummySVG"></div>
          {this.state.renderSVG ? (
            <svg
              ref="svg"
              width={this.state.width}
              height={this.state.height}
            ></svg>
          ) : (
            ""
          )}
        </div>
      </div>
    );
  }
}
